/**
 * @generated SignedSource<<1e46ee12c5990a431d6a0246c6d7de03>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useViewedComments_read$data = {
  readonly commentIds: ReadonlyArray<string | null | undefined>;
  readonly " $fragmentType": "useViewedComments_read";
};
export type useViewedComments_read$key = {
  readonly " $data"?: useViewedComments_read$data;
  readonly " $fragmentSpreads": FragmentRefs<"useViewedComments_read">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useViewedComments_read",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "commentIds"
    }
  ],
  "type": "ViewedComments"
};

(node as any).hash = "8133cc01831582777d2e0911570e19eb";

export default node;
